import { Floors } from "../redux/services/config";

export const getFormattedFloors = (floors: Floors) =>
  Object.values(floors).map((floor) => floor);
